import styles from 'components/FeatureGarden/PillBubble/PillBubble.module.scss';

import cx from 'classnames';
import React, { FC, useState, useRef } from 'react';

import { FeatureGardenPillProps, BubblePositon } from '../FeatureGarden';
import { PillBubble } from '../PillBubble/PillBubble';
import { PillModal } from '../PillModal/PillModal';
import { SubjectImage } from 'components/SubjectImage/SubjectImage';
import { TextV2 } from 'components/TextV2/TextV2';
import { useBreakpoints } from 'hooks/useBreakpoints';

const NO_ICON_BUTTON_LEFT = 12;

export const PillButton: FC<FeatureGardenPillProps> = entry => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { browser } = useBreakpoints();
  const isDesktopOrLarge = browser.is.desktop;
  const buttonRef = useRef<HTMLButtonElement>(null);
  let bubblePosition: BubblePositon | undefined;

  // gets the position of the button relative to the parent element
  if (buttonRef?.current?.parentElement) {
    const buttonRect = buttonRef.current.getBoundingClientRect();
    const parentRect = buttonRef.current.parentElement.getBoundingClientRect();
    const paddingOffset = 10;
    const closeButtonWidth = 50;

    bubblePosition = {
      top: buttonRect.top - parentRect.top,
      left: buttonRect.left - parentRect.left + (entry.image ? 0 : NO_ICON_BUTTON_LEFT),
      width: buttonRect.width - paddingOffset + closeButtonWidth,
      initialWidth: buttonRect.width,
      height: buttonRect.height,
    };
  }

  return (
    <>
      <button
        ref={buttonRef}
        className={cx(styles.pill, {
          [styles.pillNoIcon]: !entry.image?.file?.url,
        })}
        onClick={() => {
          entry.onRequestClose?.();
          setIsModalOpen(true);
        }}
        onFocus={entry.onRequestClose}
      >
        <SubjectImage entry={entry} className={styles.pillImage} />
        <TextV2 variant={entry.titleStyle} value={entry.title} className={styles.pillTitle} />
      </button>
      {isDesktopOrLarge && isModalOpen && bubblePosition ? (
        <PillBubble
          {...entry}
          {...bubblePosition}
          isModalOpen={isModalOpen}
          onRequestClose={() => setIsModalOpen(false)}
        />
      ) : (
        <PillModal {...entry} isModalOpen={isModalOpen} onRequestClose={() => setIsModalOpen(false)} />
      )}
    </>
  );
};
